import { connect } from 'react-redux';
import { OPERATIONS } from '../../constants';
import ProcessValidationGeonealogy from '../ProcessValidation/ProcessValidationGeonealogy';
import ProcessValidationStages from '../ProcessValidation/ProcessValidationStages';

const mapStateToProps = (state) => {
  return {
    allowedOperations: state.operations.allowedOperations,
  };
};

const ProcessValidationContainer = ({ allowedOperations }) => {
  if (allowedOperations.includes(OPERATIONS.BOOK)) {
    // return <ProcessValidationGeonealogy />;
  }
  return <ProcessValidationStages/>;
};

export default connect(mapStateToProps)(ProcessValidationContainer);
